export const BRL = (v) =>
  (v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const MESES = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

export const fmtData = (d) => {
  if (!d) return "—";
  const [y, m, day] = d.split("-");
  return `${day}/${m}/${y}`;
};

export const slugify = (value = "") => value
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/^-+|-+$/g, "") || "cliente";

export const editorialPublicPath = (cliente) =>
  `/editorial/${slugify(cliente?.empresa)}/${cliente?.editorial_token}`;

// O calendário editorial e a programação de posts ficam no Nexus.
export const NEXUS_URL = (process.env.REACT_APP_NEXUS_URL || "https://nexus.netzerstudio.com.br/nexus").replace(/\/$/, "");
export const nexusClientUrl = (cliente) =>
  cliente?.empresa ? `${NEXUS_URL}?cliente=${encodeURIComponent(cliente.empresa)}` : NEXUS_URL;

export const ETAPAS = [
  { key: "planejamento", nome: "Planejamento", cor: "#3B82F6" },
  { key: "pre_producao", nome: "Pré-produção", cor: "#8B5CF6" },
  { key: "captacao", nome: "Captação", cor: "#EC4899" },
  { key: "pos_producao", nome: "Pós-produção", cor: "#F59E0B" },
  { key: "aprovacao", nome: "Aprovação", cor: "#10B981" },
  { key: "programacao", nome: "Programação", cor: "#06B6D4" },
  { key: "publicacao", nome: "Publicação", cor: "#14B8A6" },
  { key: "finalizado", nome: "Finalizado", cor: "#4ADE80" },
];

export const STATUS_CICLO = {
  cancelado: { nome: "Cancelado", cor: "#71717A" },
  nao_iniciado: { nome: "Não iniciado", cor: "#71717A" },
  em_andamento: { nome: "Em andamento", cor: "#3B82F6" },
  aguardando_cliente: { nome: "Aguardando cliente", cor: "#F59E0B" },
  bloqueado: { nome: "Bloqueado", cor: "#F43F5E" },
  concluido: { nome: "Concluído", cor: "#4ADE80" },
};

export const SAUDE = {
  saudavel: { nome: "Saudável", cor: "#8CC63F" },
  atencao: { nome: "Atenção", cor: "#F59E0B" },
  risco: { nome: "Em risco", cor: "#F43F5E" },
};

export const STATUS_CLIENTE = {
  ativo: { nome: "Ativo", cor: "#8CC63F" },
  pausado: { nome: "Pausado", cor: "#F59E0B" },
  encerrado: { nome: "Encerrado", cor: "#71717A" },
  onboarding: { nome: "Onboarding", cor: "#06B6D4" },
};

export const PRIORIDADES = {
  baixa: { nome: "Baixa", cor: "#71717A" },
  media: { nome: "Média", cor: "#3B82F6" },
  alta: { nome: "Alta", cor: "#F43F5E" },
};

export const STATUS_TAREFA = {
  cancelado: { nome: "Cancelada", cor: "#71717A" },
  nao_iniciado: { nome: "Não iniciada", cor: "#71717A" },
  em_andamento: { nome: "Em andamento", cor: "#3B82F6" },
  concluido: { nome: "Concluída", cor: "#4ADE80" },
};

export const FUNCOES = ["Diretor", "Atendimento", "Estratégia", "Videomaker", "Fotógrafo", "Editor", "Nexus", "Social Media", "Financeiro"];

export const TIPOS_CICLO = [
  { key: "mensal", nome: "Mensal" },
  { key: "campanha", nome: "Campanha" },
  { key: "temporada", nome: "Temporada" },
  { key: "projeto", nome: "Projeto" },
  { key: "acao_especial", nome: "Ação especial" },
  { key: "pontual", nome: "Pontual" },
];

export const FREQ_CAPTACAO = [
  { key: "mensal", nome: "Mensal" },
  { key: "bimestral", nome: "Bimestral" },
  { key: "trimestral", nome: "Trimestral" },
  { key: "personalizada", nome: "Personalizada" },
  { key: "pontual", nome: "Pontual" },
];

export const STATUS_GRAVACAO = {
  planejando: { nome: "Planejando", cor: "#71717A" },
  agendada: { nome: "Agendada", cor: "#3B82F6" },
  confirmada: { nome: "Confirmada", cor: "#8CC63F" },
  realizada: { nome: "Realizada", cor: "#4ADE80" },
  cancelada: { nome: "Cancelada", cor: "#F43F5E" },
};

export const STAGES = [
  { key: "qualificar", nome: "Qualificar", grupo: "pipeline" },
  { key: "diagnostico", nome: "Diagnosticar", grupo: "pipeline" },
  { key: "proposta", nome: "Propor", grupo: "pipeline" },
  { key: "decisao", nome: "Decidir", grupo: "pipeline" },
  { key: "nutricao", nome: "Nutrição", grupo: "historico" },
  { key: "ganho", nome: "Ganho", grupo: "historico" },
  { key: "perdido", nome: "Perdido", grupo: "historico" },
];

export const STAGE_ALIASES = {
  lead: "qualificar",
  qualificacao: "qualificar",
  reuniao: "diagnostico",
  negociacao: "decisao",
};

export const normalizeStage = (key) => STAGE_ALIASES[key] || key || "qualificar";
export const PIPELINE_STAGES = STAGES.filter((stage) => stage.grupo === "pipeline");
export const HISTORY_STAGES = STAGES.filter((stage) => stage.grupo === "historico");

export const TIPOS_EVENTO = [
  { key: "gravacao_estudio", nome: "Gravação no Estúdio", cor: "#EC4899" },
  { key: "captacao_externa", nome: "Captação Externa", cor: "#F59E0B" },
  { key: "reuniao", nome: "Reunião de Alinhamento", cor: "#3B82F6" },
  { key: "roteiro", nome: "Entrega de Roteiro", cor: "#8B5CF6" },
  { key: "entrega", nome: "Entrega de Material", cor: "#10B981" },
  { key: "postagem", nome: "Postagem Programada", cor: "#06B6D4" },
];

export const etapaInfo = (k) => ETAPAS.find((e) => e.key === k) || ETAPAS[0];
export const stageInfo = (k) => STAGES.find((s) => s.key === normalizeStage(k)) || STAGES[0];
export const tipoEventoInfo = (k) => TIPOS_EVENTO.find((t) => t.key === k) || TIPOS_EVENTO[2];

export const STATUS_TX = {
  previsto: { nome: "Previsto", cor: "#71717A" },
  pendente: { nome: "Pendente", cor: "#F59E0B" },
  parcial: { nome: "Recebido parcial", cor: "#F59E0B" },
  recebido: { nome: "Recebido", cor: "#10B981" },
  pago: { nome: "Pago", cor: "#10B981" },
  atrasado: { nome: "Atrasado", cor: "#F43F5E" },
};

export const BROTO_URL = "/assets/netzer-broto.png";
export const LOGO_ROUND_URL = "/assets/netzer-logo-round.png";

export const TIPOS_CONTEUDO = [
  { key: "reels", nome: "Reels" },
  { key: "carrossel", nome: "Carrossel" },
  { key: "foto", nome: "Foto única" },
  { key: "stories", nome: "Stories" },
  { key: "video", nome: "Vídeo longo" },
];

export const REDES = [
  { key: "instagram", nome: "Instagram", cor: "#EC4899" },
  { key: "tiktok", nome: "TikTok", cor: "#06B6D4" },
  { key: "youtube", nome: "YouTube", cor: "#F43F5E" },
  { key: "linkedin", nome: "LinkedIn", cor: "#3B82F6" },
  { key: "facebook", nome: "Facebook", cor: "#8B5CF6" },
];

export const POST_STATUS = {
  rascunho: { nome: "Rascunho", cor: "#71717A" },
  planejado: { nome: "Planejado", cor: "#71717A" },
  em_aprovacao: { nome: "Em aprovação", cor: "#F59E0B" },
  ajustes_solicitados: { nome: "Ajustes solicitados", cor: "#F43F5E" },
  aprovado: { nome: "Aprovado", cor: "#8CC63F" },
  agendado: { nome: "Agendado", cor: "#3B82F6" },
  publicado: { nome: "Publicado", cor: "#06B6D4" },
  postado: { nome: "Publicado", cor: "#06B6D4" },
};

export const redeInfo = (k) => REDES.find((r) => r.key === k) || REDES[0];
export const tipoConteudoInfo = (k) => TIPOS_CONTEUDO.find((t) => t.key === k) || TIPOS_CONTEUDO[0];
